import { NgZone } from '@angular/core';
import { AGORA, AgoraData, ConferenceData, VideoConferenceProvider, VOXEET } from '../definitions';
import { AgoraProvider } from './agora.provider';
import { AgoraApiProviderService } from '@project/data-providers';

export class VideoconferenceFactoryProvider {
  public getProvider(
    conferenceData: ConferenceData,
    agoraApiService: AgoraApiProviderService,
    enableSTT: boolean,
    ngZone: NgZone,
  ): VideoConferenceProvider {
    switch (conferenceData.provider.toUpperCase()) {
      case AGORA:
        return new AgoraProvider(conferenceData as AgoraData, agoraApiService, enableSTT, ngZone);
      case VOXEET:
        return null;
      default:
        return null;
    }
  }

  public getDevicePreviewProvider(agoraApiService: AgoraApiProviderService, ngZone: NgZone): VideoConferenceProvider {
    return new AgoraProvider(null, agoraApiService, false, ngZone);
  }
}
